import { Component, OnInit } from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatRippleModule } from '@angular/material/core';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SessionCleanupService } from 'src/app/services/session-cleanup.service';


@Component({
    selector: 'vex-sidenav-user-menu',
    templateUrl: './sidenav-user-menu.component.html',
    styleUrls: ['./sidenav-user-menu.component.scss'],
    imports: [MatRippleModule, RouterLink, MatIconModule]
})
export class SidenavUserMenuComponent implements OnInit {

  constructor(private readonly popoverRef: VexPopoverRef,
    private readonly sessionCleanup: SessionCleanupService
    ) {

  }

  ngOnInit(): void {}

  close(): void {
    /** Wait for animation to complete and then close */
    setTimeout(() => this.popoverRef.close(), 250);
  }

  logout() {
    this.sessionCleanup.logoutToLogin();
    setTimeout(() => this.popoverRef.close(), 250);

  }
}
